<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-1"><a id="page_x">Abbreviations</a></h1><a id="page_x">
<table>
<tbody>
<tr>
<td class="col1"><p class="t-left"><em>AG</em></p></td>
<td class="col2"><p class="t-left"><em>Ad Gentes: Decree on the Mission Activity of the Church</em> (Vatican II). <a href="http://www.vatican.va/archive/hist_councils/ii_vatican_council/documents/vat-ii_decree_19651207_ad-gentes_en.html" target="_blank">http://www.vatican.va/archive/hist_councils/ii_vatican_council/documents/vat-ii_decree_19651207_ad-gentes_en.html</a></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">Aquinas, <em>ST</em></p></td>
<td class="col2"><p class="t-left"><em>The Summa Theologica of St. Thomas Aquinas</em>. 2nd and rev. ed. 1920. Literally translated by Fathers of the English Dominican Province. Online edition. Copyright © 2008 by Kevin Knight. <a href="http://www.newadvent.org/summa/" target="_blank">http://www.newadvent.org/summa/</a></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">Barth, <em>CD</em></p></td>
<td class="col2"><p class="t-left">Karl Barth. <em>Church Dogmatics</em>. Edited by G. W. Bromiley and T. F. Torrance. Translated by G. W. Bromiley. Edinburgh: T. &amp; T. Clark, 1956–1975. Online edition by Alexander Street Press, 1975</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>BC</em></p></td>
<td class="col2"><p class="t-left"><em>The Book of Concord. The Confessions of the Evangelical Lutheran Church</em>. Translated by Theodore G. Tappert. Philadelphia: Fortress, 1959</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>BCSC</em></p></td>
<td class="col2"><p class="t-left"><em>The Blackwell Companion to Science and Christianity</em>. Edited by J. B. Stump and Alan G. Padgett. Malden, Mass., and Oxford: Blackwell, 2012</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>BEM</em></p></td>
<td class="col2"><p class="t-left"><em>Baptism, Eucharist and Ministry</em>. Faith and Order, 1982</p></td>
</tr>
<tr>
<td class="col1"></td>
<td class="col2"><p class="abbr2"><em>BEM</em>-B = Baptism section</p></td>
</tr>
<tr>
<td class="col1"></td>
<td class="col2"><p class="abbr2"><em>BEM</em>-E = Eucharist section</p></td>
</tr>
<tr>
<td class="col1"></td>
<td class="col2"><p class="abbr2"><em>BEM</em>-M = Ministry section</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">CA</p></td>
<td class="col2"><p class="t-left">Confessio Augustana (= Augsburg Confession)</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CCCIT</em></p></td>
<td class="col2"><p class="t-left"><em>The Cambridge Companion to Classical Islamic Theology</em>. <a id="page_xi">Edited by Tim Winter. Cambridge: Cambridge University Press, 2008. Online edition</a></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CC-LCE</em></p></td>
<td class="col2"><p class="t-left"><em>The Church as Communion: Lutheran Contributions to Ecclesiology</em>. Edited by Heinrich Holze. Geneva: Lutheran World Federation, 1997</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CTCV</em></p></td>
<td class="col2"><p class="t-left"><em>The Church: Towards a Common Vision</em>. Faith and Order Paper no. 214. 2013</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CWMRW</em></p></td>
<td class="col2"><p class="t-left"><em>Christian Witness in a Multi-Religious World: Recommendations for Conduct</em>. World Council of Churches, Pontifical Council for Interreligious Dialogue, World Evangelical Alliance, 2011</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>DAR</em></p></td>
<td class="col2"><p class="t-left"><em>Death and Afterlife: Perspectives of World Religions</em>. Edited by Hiroshi Obayashi. London: Praeger, 1992</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>DIRW</em></p></td>
<td class="col2"><p class="t-left"><em>Death and Immortality in the Religions of the World</em>. Edited by Paul Badham and Linda Badham. New York: Paragon House, 1987</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>EPCW</em></p></td>
<td class="col2"><p class="t-left"><em>Evangelization, Proselytism, and Common Witness: The Report from the Fourth Phase of the International Dialogue between the Roman Catholic Church and Some Classical Pentecostal Churches and Leaders, 1990–</em>1997. <a href="http://www.prounione.urbe.it" target="_blank">http://www.prounione.urbe.it/dia-int/pe-rc/doc/i_pe-rc_pento4.html</a></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>ER</em></p></td>
<td class="col2"><p class="t-left"><em>Encyclopedia of Religion</em>. Edited by Lindsay Jones. 15 vols. 2nd ed. Detroit: Macmillan Reference USA/Gale, Cengage Learning, 2005</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>EWEG</em></p></td>
<td class="col2"><p class="t-left"><em>The End of the World and the Ends of God: Science and Theology on Eschatology</em>. Edited by John Polkinghorne and Michael Welker. Harrisburg, Pa.: Trinity, 2000</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>FFU</em></p></td>
<td class="col2"><p class="t-left"><em>The Far-Future Universe: Eschatology from a Cosmic Perspective</em>. Edited by George F. R. Ellis. Philadelphia and London: Templeton Foundation Press, 2002</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>GDT</em></p></td>
<td class="col2"><p class="t-left"><em>Global Dictionary of Theology</em>. Edited by Veli-Matti Kärkkäinen and William Dyrness. Assistant editors, Simon Chan and Juan Martinez. Downers Grove: InterVarsity, 2008</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">Haight, <em>CCH</em></p></td>
<td class="col2"><p class="t-left">Roger Haight, SJ. <em>Christian Community in History</em>. Vol. 1, <em>Historical Ecclesiology</em>. Vol. 2, <em>Comparative Ecclesiology</em>. Vol. 3, <em>Ecclesial Existence</em>. New York and London: Continuum, 2004, 2005, 2008</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><a id="page_xii"><em>JBC</em></a></p></td>
<td class="col2"><p class="t-left"><em>Jesus beyond Christianity: The Classic Texts</em>. Edited by Gregory A. Barker and Stephen E. Gregg. Oxford: Oxford University Press, 2010</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JWF</em></p></td>
<td class="col2"><p class="t-left"><em>Jesus in the World’s Faiths: Leading Thinkers from Five Religions Reflect on His Meaning</em>. Edited by Gregory A. Barker. Maryknoll, N. Y.: Orbis, 2008</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">Kasper, <em>HTF</em></p></td>
<td class="col2"><p class="t-left">Cardinal Walter Kasper. <em>Harvesting the Fruits: Basic Aspects of Christian Faith in Ecumenical Dialogue</em>. London and New York: Continuum, 2009</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>LDWR</em></p></td>
<td class="col2"><p class="t-left"><em>Life after Death in World Religions</em>. Edited by Harold Coward. Maryknoll, N. Y.: Orbis, 1997</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>LG</em></p></td>
<td class="col2"><p class="t-left"><em>Lumen Gentium: The Dogmatic Constitution on the Church</em>. Solemnly Promulgated by His Holiness Pope Paul VI on November 21, 1964 (Vatican II). <a href="http://www.vatican.va/archive/hist_councils/ii_vatican_council/documents/vat-ii_const_19641121_lumen-gentium_en.html" target="_blank">http://www.vatican.va/archive/hist_councils/ii_vatican_council/documents/vat-ii_const_19641121_lumen-gentium_en.html</a></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>LW</em></p></td>
<td class="col2"><p class="t-left"><em>Luther’s Works</em>. American ed. (Libronix Digital Library). Edited by Jaroslav Pelikan and Helmut T. Lehman. 55 vols. Minneapolis: Fortress, 2002</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NMC</em></p></td>
<td class="col2"><p class="t-left"><em>The Nature and Mission of the Church: A Stage on the Way to a Common Statement</em>. Faith and Order Paper no. 198. 2005</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NPNF</em><sup>1</sup></p></td>
<td class="col2"><p class="t-left"><em>A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church</em>. Edited by Philip Schaff. 1st ser. 14 vols. Edinburgh, 1886. Public domain; available at <a href="http://www.ccel.org" target="_blank">www.ccel.org</a></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>NPNF</em><sup>2</sup></p></td>
<td class="col2"><p class="t-left"><em>A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church</em>. Edited by Philip Schaff and Henry Wace. 2nd ser. 14 vols. Edinburgh, 1890. Public domain; available at <a href="http://www.ccel.org" target="_blank">www.ccel.org</a></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>OBTMR</em></p></td>
<td class="col2"><p class="t-left"><em>One Baptism: Towards Mutual Recognition; A Study Text</em>. Faith and Order Paper no. 210. 2011</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>OHE</em></p></td>
<td class="col2"><p class="t-left"><em>Oxford Handbook of Eschatology</em>. Edited by Jerry L. Walls. New York: Oxford University Press, 2009. Online edition</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>OHGR</em></p></td>
<td class="col2"><p class="t-left"><em>The Oxford Handbook of Global Religions</em>. Edited by Mark Juergensmeyer. New York: Oxford University Press, 2006</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>OHM</em></p></td>
<td class="col2"><p class="t-left"><em>The Oxford Handbook of Millennialism</em>. Edited by Catherine Wessinger. New York: Oxford University Press, 2011. Online edition</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><a id="page_xiii"><em>OHRD</em></a></p></td>
<td class="col2"><p class="t-left"><em>The Oxford Handbook of Religious Diversity</em>. Edited by Chad Meister. Oxford: Oxford University Press, 2010</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">Pannenberg, <em>ST</em></p></td>
<td class="col2"><p class="t-left">Wolfhart Pannenberg. <em>Systematic Theology</em>. Translated by Geoffrey W. Bromiley. 3 vols. Grand Rapids: Eerdmans, 1991, 1994, 1998</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>PC</em></p></td>
<td class="col2"><p class="t-left"><em>Physics and Cosmology: Scientific Perspectives on the Problem of Natural Evil</em>. Edited by Nancey Murphy, Robert John Russell, William R. Stoeger, SJ. Vol. 1. Vatican City and Berkeley, Calif.: Vatican Observatory and Center for Theological and the Natural Sciences, 2007</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>PE</em></p></td>
<td class="col2"><p class="t-left"><em>The Problem of Evil</em>. Edited by M. M. Adams and R. M. Adams. Oxford: Oxford University Press, 1990</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">Pelikan, <em>CT</em></p></td>
<td class="col2"><p class="t-left">Jaroslav Pelikan. <em>The Christian Tradition: A History of the Development of Doctrine</em>. Vol. 1, <em>The Emergence of the Catholic Tradition (100–600)</em>. Vol. 2, <em>The Spirit of Eastern Christendom (600–1700)</em>. Vol. 3, <em>The Growth of Medieval Theology (600–1300)</em>. Vol. 4, <em>Reformation of Church and Dogma (1300–1700)</em>. Chicago: University of Chicago Press, 1971, 1974, 1978, 1984</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>PIR</em></p></td>
<td class="col2"><p class="t-left"><em>Personal Identity and Resurrection: How Do We Survive Our Death?</em> Edited by Georg Gasser. Surrey, UK: Ashgate, 2010</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>QCLN</em></p></td>
<td class="col2"><p class="t-left"><em>Quantum Cosmology and the Laws of Nature: Scientific Perspectives on Divine Action</em>. Edited by Robert John Russell, Nancey Murphy, and C. J. Isham. Vatican City: Vatican Observatory Publications, 1993</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>RCCC</em></p></td>
<td class="col2"><p class="t-left"><em>Routledge Companion to the Christian Church</em>. Edited by Gerard Mannion and Lewis S. Mudge. New York: Routledge, 2012</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>RTSA</em></p></td>
<td class="col2"><p class="t-left"><em>Resurrection: Theological and Scientific Assessments</em>. Edited by T. Peters, R. J. Russell, and M. Welker. Grand Rapids: Eerdmans, 2002</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>SBE</em></p></td>
<td class="col2"><p class="t-left"><em>Sacred Books of the East</em>. Translated by Max Müller. 50 vols. Oxford: Oxford University Press, 1879–1910. Also available at <a href="http://www.sacred-texts.com" target="_blank">www.sacred-texts.com</a></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">Schleiermacher, <em>CF</em></p></td>
<td class="col2"><p class="t-left">Friedrich Schleiermacher. <em>The Christian Faith</em>. Edited by H. R. Mackintosh and J. S. Stewart. London and New York: T. &amp; T. Clark, 1999</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>SPDA</em></p></td>
<td class="col2"><p class="t-left"><em>Scientific Perspectives on Divine Action: Twenty Years of <a id="page_xiv">Challenge and Progress</a></em><a id="page_xiv">. Edited by Robert John Russell, Nancey Murphy, and William R. Stoeger, SJ. Vatican City and Berkeley, Calif.: Vatican Observatory and Center for Theological and the Natural Sciences, 2008</a></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">TCW</p></td>
<td class="col2"><p class="t-left">“Towards Common Witness: A Call to Adopt Responsible Relationships in Mission and to Renounce Proselytism.” WCC and the Vatican, 1997</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">Tillich, <em>ST</em></p></td>
<td class="col2"><p class="t-left">Paul Tillich. <em>Systematic Theology</em>. 3 vols. Chicago: University of Chicago Press, 1951, 1957, 1963</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>TTL</em></p></td>
<td class="col2"><p class="t-left"><em>Together towards Life: Mission and Evangelism in Changing Landscapes</em>. Commission on World Mission and Evangelism/WCC, 2012</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>UR</em></p></td>
<td class="col2"><p class="t-left"><em>Unitatis Redintegratio: Decree on Ecumenism</em> (Vatican II)</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">WA</p></td>
<td class="col2"><p class="t-left">Weimarer Ausgabe (the Weimar edition of Luther’s works)</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">WCC</p></td>
<td class="col2"><p class="t-left">World Council of Churches</p></td>
</tr>
</tbody>
</table>
<p class="para1">Bible references, unless otherwise indicated, are from the Revised Standard Version of the Bible, copyright 1952 (2nd ed. 1971) by the Division of Christian Education of the National Council of the Churches of Christ in the United States of America. Used by permission. All rights reserved.</p>
<p class="indent-para">Unless otherwise indicated, all citations from patristic writers come from the standard series listed above.</p>
</a><p class="indent-para"><a id="page_x">Josephus’s writings are from the Sacred Texts Web site: </a><a href="http://www.sacred-texts.com/jud/josephus/index.htm" target="_blank">http://www.sacred-texts.com/jud/josephus/index.htm</a>.</p>
<p class="indent-para">Unless otherwise indicated, contemporary Roman Catholic documents, documents of Vatican II, papal encyclicals, and similar works are quoted from the official Vatican Web site: <a href="http://www.vatican.va" target="_blank">www.vatican.va</a>. This includes also dialogue documents with Lutherans, Reformed, Anglicans, Methodists, and Pentecostals.</p>
<p class="indent-para">Contemporary World Council of Churches documents are quoted from their official Web site, <a href="http://www.oikoumene.org/" target="_blank">http://www.oikoumene.org/</a>, unless otherwise indicated.</p>
<p class="indent-para">The sources used for postbiblical Jewish literature are as follows:</p>
<p class="indent-para">Midrashic commentary literature is from <em>Midrash Rabbah</em>. Translated and edited by H. Freedman and Maurice Simon. 10 vols. 3rd imprint. London: Soncino Press, 1961 (1939). Available at <a href="https://archive.org/details/RabbaGenesis" target="_blank">https://archive.org/details/RabbaGenesis</a>.</p>
<p class="indent-para">Talmud references are from <em>The Babylonian Talmud</em>. Translated and edited by I. Epstein. 35 vols. London: Soncino Press, 1952. Available at <a href="http://www.come-and-hear.com/tcontents.html" target="_blank">http://www.come-and-hear.com/tcontents.html</a>.</p>
<p class="indent-para"><a id="page_xv">Mishnah texts are from </a><a href="http://eMishnah.com" target="_blank">eMishnah.com</a> (2008) at <a href="http://www.emishnah.com/Yoma.html" target="_blank">http://www.emishnah.com/Yoma.html</a>.</p>
<p class="indent-para">All others, unless otherwise noted, are from <a href="http://www.earlyjewishwritings.com/" target="_blank">http://www.earlyjewishwritings.com/</a> (e.g., Philo of Alexandria).</p>
<p class="indent-para">The Qur’anic references, unless otherwise indicated, are from <em>The Holy Qur’ān: A New English Translation of Its Meanings</em> © 2008 Royal Aal al-Bayt Institute for Islamic Thought, Amman, Jordan. This version of the Qur’an is also available online at <a href="http://altafsir.com" target="_blank">http://altafsir.com</a>.</p>
<p class="indent-para">Hadith texts are from the Hadith Collection Web site: <a href="http://www.hadithcollection.com/" target="_blank">http://www.hadithcollection.com/</a> (2009–).</p>
<p class="indent-para">Buddhist texts, unless otherwise indicated, are from “Tipitaka: The Pali Canon.” Edited by John T. Bullitt. <em>Access to Insight</em>, May 10, 2011. Available at <a href="http://www.accesstoinsight.org/tipitaka/index.html" target="_blank">http://www.accesstoinsight.org/tipitaka/index.html</a>.</p>
<p class="indent-para">Bhagavad-Gita texts are from the translation by Ramanand Prasad. EAWC Anthology, 1988.</p>
<p class="indent-para">All other Hindu texts, unless otherwise indicated, are from the Sacred Texts Web site: <a href="http://www.sacred-texts.com/hin/index.htm" target="_blank">http://www.sacred-texts.com/hin/index.htm</a>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_Abbreviations.vue?eeb5155a